<div class="numeric-stepper">
    <button data-id="decrement" class="button" [disabled]="!decrementEnabled() || disabled()" (click)="decrement()">-</button>
    {{value()}}
    <button data-id="increment" class="button" [disabled]="!incrementEnabled() || disabled()" (click)="increment()">+</button>
</div>
